import { getClosest } from './helpers'
import Flickity from 'flickity'

if (! document.body.classList.contains('tax-thematique')) {
  let thematiqueEntries = document.getElementsByClassName('thematique-entry');
  if (thematiqueEntries) {
    for (let i = 0; i < thematiqueEntries.length; i ++) {
      thematiqueEntries[i].addEventListener('click', () => {
        thematiqueEntries[i].classList.toggle('triggered')
      })
    }

    document.body.addEventListener('click', () => {
      for (let i = 0; i < thematiqueEntries.length; i ++) {
        thematiqueEntries[i].classList.remove('triggered')
      }
    }, true);
  }

  // close thematique detail on close button click
  let thematiqueCloseDetail = document.getElementsByClassName('close');
  if (thematiqueCloseDetail) {
    for (let i = 0; i < thematiqueCloseDetail.length; i ++) {
      thematiqueCloseDetail[i].addEventListener('click', () => {
        getClosest(thematiqueCloseDetail[i], '.thematique-entry')
          .classList
          .toggle('triggered')
      })
    }
  }
}

let themathiqueSelect = document.getElementById('themathique-select');
if (themathiqueSelect) {
  themathiqueSelect.addEventListener('change', () => {
    window.location = themathiqueSelect.value
  })
}

let aLaUneCarousel = document.getElementById('en-savoir-plus-carousel')
if (aLaUneCarousel) {

  let utils = require('fizzy-ui-utils');
  let carousel = aLaUneCarousel

  if (carousel) {
    let flkty = new Flickity(carousel, {
      cellAlign: 'left',
      cellSelector: '.carousel-cell',
      resize: true,
      prevNextButtons: false,
      pageDots: false,
      groupCells: 2
    })

    // used for transition: the opacity was 0 before the carousel is loaded
    carousel.style.opacity = 1

    // previous
    let previousButton = document.querySelector('.button--previous');
    previousButton.addEventListener('click', function () {
      flkty.previous();
    })

    // next
    let nextButton = document.querySelector('.button--next');
    nextButton.addEventListener('click', function () {
      flkty.next();
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/includes/themathiques.js